import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Privacy() {
  useEffect(() => {
    document.title = "Privacy Policy | Get Online Crew";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main
        className="bg-white"
        data-testid="privacy-page"
      >
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <p className="text-sm font-semibold uppercase tracking-widest text-goc-primary mb-3">
            Legal
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-goc-text">
            Privacy Policy
          </h1>
          <p className="mt-4 text-sm text-goc-muted">
            This policy may be updated as our services evolve. Please review it
            periodically.
          </p>

          <div className="mt-10 space-y-8 text-goc-text leading-relaxed">
            <section>
              <h2 className="text-xl font-bold">Who this policy applies to</h2>
              <p className="mt-2 text-goc-muted">
                This policy applies to visitors of GetOnlineCrew.com and to
                people who contact us through this website. It describes the
                information we collect and how we use it.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold">Information we collect</h2>
              <p className="mt-2 text-goc-muted">
                When you submit our lead form, we collect the information you
                choose to provide — your full name, business name, email
                address, phone number, city and state, business type, an
                optional current website URL, an optional domain status, and a
                short description of your business.
              </p>
              <p className="mt-2 text-goc-muted">
                We also collect limited technical information related to your
                submission:
              </p>
              <ul className="mt-2 space-y-1.5 text-goc-muted list-disc pl-6">
                <li>
                  Your browser&apos;s user-agent string (used to help debug
                  submissions when problems occur).
                </li>
                <li>
                  A hashed IP-derived identifier used only for abuse
                  prevention and rate limiting. We do <strong>not</strong>{" "}
                  store your raw IP address.
                </li>
                <li>
                  Campaign attribution parameters, if present in the URL
                  (<code>utm_source</code>, <code>utm_medium</code>,{" "}
                  <code>utm_campaign</code>, <code>utm_content</code>,{" "}
                  <code>utm_term</code>) and the landing page you arrived on.
                  These help us understand where inquiries come from.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold">How we use your information</h2>
              <p className="mt-2 text-goc-muted">
                We use the information you provide to respond to your inquiry,
                understand your needs, prepare a proposal or estimate, and
                provide website services if you choose to work with us. We do
                not sell your personal information.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold">How we store your information</h2>
              <p className="mt-2 text-goc-muted">
                We store submitted information using reasonable measures to
                protect it. No online service can guarantee absolute security,
                but we work to keep your information reasonably safe.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold">Third parties</h2>
              <p className="mt-2 text-goc-muted">
                We may use third-party providers to help operate this website
                and communicate with you (for example, hosting or email
                delivery). Those providers process information on our behalf.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold">Your choices</h2>
              <p className="mt-2 text-goc-muted">
                You may contact us to request access to, correction of, or
                deletion of information you have submitted. Once we launch
                contact channels publicly, they will be listed on this site.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold">Changes to this policy</h2>
              <p className="mt-2 text-goc-muted">
                This policy may change as our services evolve. When we update
                it, we will change the date and post the updated version on
                this page.
              </p>
            </section>

            <section>
              <p className="text-sm text-goc-muted">
                This policy is informational and is not a legal contract. It
                describes our current practices and will be updated as our
                services grow.
              </p>
              <p className="mt-6">
                <Link
                  to="/"
                  className="text-goc-primary font-semibold hover:text-goc-deep transition-colors"
                  data-testid="privacy-back-home"
                >
                  ← Back to home
                </Link>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
